import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchLedgermap } from "../data/actions";
import * as select from "../data/selectors";
import { Grid, Button, Icon } from "semantic-ui-react";
import { heightSet  } from "../../../utilities/heightSet";
import { searchColumns } from "../data/model";
import { TableListDiv } from "../../../utilities/tableListDiv";

const LedgermapList = (props) => {
  const dispatch = useDispatch();
  const ledgermap = useSelector((state) => select.getFilteredLedgermap(state));
  const [heights, setHeight] = useState("");

  useEffect(() => {
    dispatch(fetchLedgermap());
  }, [dispatch]);

  const callHeightFunc = () => {
    heightSet(setHeight);
  };

  useEffect(() => {
    callHeightFunc();
    window.addEventListener(
      "resize",
      function () {
        callHeightFunc();
      },
      false
    );
    // Cleanup function to remove event listener when component unmounts
    return () => {
      window.removeEventListener("resize", callHeightFunc);
    };
  }, []);

  const ledgermapAction = ({ object: obj }) => {
    return (
      <>
        <Link to={"/ledgermap/edit/" + obj.id} title="Edit">
          <Icon name="edit" color="blue" link />
        </Link>
        <span style={{ color: "#cfd8e3", margin: "0 6px" }}>|</span>
        <Link to={"/ledgermap/clone/" + obj.id} title="Clone">
          <Icon name="copy outline" color="teal" link />
        </Link>
      </>
    );
  };
  const redirectToAddLedgerMap = () => {
    props.history.push({ pathname: "/ledgermap/create" });
  };

  return (
    <>
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 4px 12px",
      }}>
        <div>
          <div style={{ fontSize: "17px", fontWeight: 600, color: "#1f2d3d", lineHeight: 1.2 }}>
            Ledger Map
          </div>
          <div style={{ fontSize: "12px", color: "#8a96a8", marginTop: "2px" }}>
            Manage DMS to RealBooks ledger mapping.
          </div>
        </div>
        <Button
          onClick={redirectToAddLedgerMap}
          type="button"
          color="blue"
          size="small"
          icon
          labelPosition="left"
        >
          <Icon name="plus" />
          Add Ledger
        </Button>
      </div>
      <div className="" style={{ paddingTop: "10px" }}>
        <TableListDiv
          columns={searchColumns}
          data={ledgermap}
          Actions={ledgermapAction}
          setHeight={parseFloat(heights) - 180}
          getIndex={6}
          filterBoxNone={""}
          rightBox={""}
          centerBox={""}
          callHeightFunc={callHeightFunc}
          paddingShort={2}
          getWidth={"100%"}
          actionClass={"actionTdDR"}
        />
      </div>
    </>
  );
};

export default LedgermapList;
